import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import OpenBankingExplainer from '@/components/ModalRenderer/components/components/OpenBankingExplainer';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

type Props = ModalProps<{
  onContinueWithoutOpenBanking?: () => void;
  onContinueWithOpenBanking: () => void;
}>;

const OpenBankingInfo = ({
  closeModal,
  payload: { onContinueWithoutOpenBanking, onContinueWithOpenBanking },
}: Props) => {
  const { t } = useTranslation('Modal', { keyPrefix: 'OpenBankingInfo' });

  return (
    <Modal title={t('title')}>
      <OpenBankingExplainer />
      <ModalActions>
        <Button
          onClick={() => {
            closeModal();
            onContinueWithOpenBanking();
          }}
        >
          {t('continueWithButton')}
        </Button>
        {!!onContinueWithoutOpenBanking && (
          <Button
            variant="secondary"
            onClick={() => {
              closeModal();
              onContinueWithoutOpenBanking();
            }}
          >
            {t('continueWithoutButton')}
          </Button>
        )}
      </ModalActions>
    </Modal>
  );
};

export default OpenBankingInfo;
